export const shadows = {
  elevations: {
    elevation01: "0px 5px 10px -5px rgba(0, 0, 0, 0.20), 0px 0px 2px 0px rgba(0, 0, 0, 0.20)",
    elevation02: "0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13), 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.10)",
    elevation03: "0px 7px 9px 0px rgba(0, 0, 0, 0.07), 0px 0px 4px 0px rgba(0, 0, 0, 0.10)",
    elevation04: "0px 8px 15px 0px rgba(0, 0, 0, 0.08), 0px 0px 2px 0px rgba(0, 0, 0, 0.05)",
  },
  innerShadows: {
    depth02: "0px 2px 7px 0px rgba(0, 0, 0, 0.10) inset",
  },
  drop: "0px -8px 9px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.05)",
}
